import { List, Map } from "lucide-react";

const ViewToggle = ({ activeTab, setActiveTab }) => {
  return (
    <div className="view-toggle" role="tablist" aria-label="Map display mode">
      <button
        type="button"
        role="tab"
        aria-selected={activeTab === "mapView"}
        onClick={() => setActiveTab("mapView")}
        className={`view-toggle__button ${
          activeTab === "mapView" ? "is-active" : ""
        }`}
      >
        <Map size={16} />
        Map
      </button>

      <button
        type="button"
        role="tab"
        aria-selected={activeTab === "listView"}
        onClick={() => setActiveTab("listView")}
        className={`view-toggle__button ${
          activeTab === "listView" ? "is-active" : ""
        }`}
      >
        <List size={16} />
        List
      </button>
    </div>
  );
};

export default ViewToggle;
